const html = document.querySelector('html');
/**
 * 判断元素是否是DOMElement
 * @return boolean
 */
export default function isDOMElement(obj: any) {
    try {
        return obj instanceof HTMLElement && obj !== html;
    }
    catch(e){
        return (
            typeof obj === "object"
                && obj.nodeType===1
                && typeof obj.style === "object"
                && typeof obj.ownerDocument ==="object"
        );
    }
}